import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import './index.css';
import brandTheme from './themes/brand';
import App from './App';
import AppProviders from './AppProviders';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const theme = extendTheme(brandTheme);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ChakraProvider theme={theme}>
    <AppProviders>
      <App/>
    </AppProviders>
  </ChakraProvider>
);